import { createSlice } from '@reduxjs/toolkit';
import { documentListModel, getProspectResponse } from '@repo/prospects-api';

const initialState: getProspectResponse = {
  headquartersCode: '',
  fiscalAddress: '',
  seller: '',
  encodedKey: '',
  state: '',
  substate: '',
  tradeName: '',
  generatedAt: '',
  stateModifiedAt: '',
  substateModifiedAt: '',
  legalName: '',
  taxpayerId: '',
  productCodes: [],
  salesChannel: '',
  localityId: 0,
  streetName: '',
  streetNumber: '',
  postalCode: '',
  legalRepresentativeFullName: '',
  legalRepresentativeEmail: '',
  legalRepresentativeMobilePhoneNumber: '',
  legalForm: '',
  documentationView: [],
  salesAgent: { id: 0, name: '' },
};

export const prospectDataSlice = createSlice({
  name: 'prospectData',
  initialState,
  reducers: {
    pushProspectData: (state, action: { payload: getProspectResponse }) => ({
      ...state,
      ...action.payload,
    }),
    pushTaxpayerId: (state, action) => ({
      ...state,
      taxpayerId: action.payload,
    }),
    pushProspectDocuments: (state, action: { payload: getProspectResponse['documentationView'] }) => ({
      ...state,
      documentationView: action.payload,
    }),
    deleteDocument: (state, action: { payload: { documentType: string; title: string; required: boolean } }) => {
      const { documentType, title, required } = action.payload;
      const updatedDocs = state.documentationView.map((doc) =>
        doc.documentType === documentType ? { documentType, title, required } : doc,
      );
      return { ...state, documentationView: updatedDocs };
    },
    uploadDocument: (state, action: { payload: documentListModel }) => {
      const updatedDocs = state.documentationView.map((doc) =>
        doc.documentType === action.payload.documentType ? action.payload : doc,
      );
      return { ...state, documentationView: updatedDocs };
    },
    resetProspectData: () => initialState,
  },
});

export const {
  pushProspectData,
  pushTaxpayerId,
  pushProspectDocuments,
  deleteDocument,
  uploadDocument,
  resetProspectData,
} = prospectDataSlice.actions;

export default prospectDataSlice.reducer;
